type ErrData = {
  tipo?: string;
  message?: string;
  stack?: string;
  info?: string;
  component?: string;
}

function obtenerRutaActual(): string {
  if (import.meta.client && typeof window !== 'undefined') {
    return window.location.pathname + window.location.search
  }
  return ''
}

const EnvioDeReporte = lodash.throttle((error: unknown, message: string, errorData: ErrData, estadoApp?: string) => {
  const rutaActual = obtenerRutaActual()
  // Enviar al backend
  Reportero.ReportarErrorAumentado({
    message,
    opciones: { error, datos: errorData },
    rutaActual,
    estadoApp
  })
}, 1000, { leading: true, trailing: false })

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = lodash.throttle((error: unknown, vm, info) => {
    // Verificar si el error es de tipo Error
    const message = (error instanceof Error) ? error.message : String(error);
    const stack = (error instanceof Error) ? error.stack : ''
    const componentName = vm?.$options?.name || 'Anonymous'
    const errorData: ErrData = {
      tipo: 'nuxtApp.vueApp.config.errorHandler',
      message,
      stack,
      info,
      component: componentName
    };
    consolo.error('errorHandler', stack, { error, vm, info, errorData })

    // Enviar al backend
    const estadoApp = `${componentName}: ${info || 'unknown'}`
    EnvioDeReporte(error, message, errorData, estadoApp)

  }, 1000, { leading: true, trailing: false });

  if (!import.meta.client) return;
  window.onerror = (message, source, lineno, colno, error: unknown) => {
    const m = String(message)
    const errorData: ErrData = {
      tipo: 'window.onerror',
      message: m,
      stack: '',
      info: `${source}:${lineno}:${colno}`,
      component: 'Anonymous'
    }
    consolo.error('window.onerror', error)
    const rutaActual = obtenerRutaActual()
    Reportero.ReportarErrorAumentado({
      message: m,
      opciones: { error, datos: errorData },
      rutaActual,
      estadoApp: 'window.onerror'
    });
  };
});
